import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Text,
  Code,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  useColorModeValue,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { RecordedProbabilities } from '../../utils/marketUtils';

interface ProbabilitiesHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  marketName: string;
  probabilitiesHistory?: RecordedProbabilities[];
}

export const ProbabilitiesHistoryModal: React.FC<ProbabilitiesHistoryModalProps> = ({
  isOpen,
  onClose,
  marketName,
  probabilitiesHistory
}) => {
  const bgColor = useColorModeValue('gray.50', 'gray.700');

  const formatTimestamp = (timestamp: string) => {
    try {
      return format(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss');
    } catch (error) {
      return timestamp;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Probabilities History: {marketName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {!probabilitiesHistory || probabilitiesHistory.length === 0 ? (
            <Text>No probability history available for this market.</Text>
          ) : (
            <>
              <Text fontWeight="bold" mb={4}>
                {probabilitiesHistory.length} entries found
              </Text>
              
              <Accordion allowMultiple defaultIndex={[0]}>
                {probabilitiesHistory.map((historyItem, index) => (
                  <AccordionItem key={index}>
                    <h2>
                      <AccordionButton>
                        <Box flex="1" textAlign="left">
                          {formatTimestamp(historyItem.createdAt)}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                      <Box 
                        bg={bgColor} 
                        p={3} 
                        borderRadius="md" 
                        overflowX="auto"
                        fontSize="sm"
                      >
                        <Code display="block" whiteSpace="pre">
                          {JSON.stringify(JSON.parse(historyItem.probabilities), null, 2)}
                        </Code>
                      </Box>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
